  <template lang="pug">
SspLayout.code-dissector(area="core")
  .recent-dissections
    span recently dissected:
    span(v-for="code in recentDissections" style="padding-right: 10px;")
      a(@click="onHistoryItemClick(code)") {{code}}
  .add-compare
    a.btn-lg.pull-right(@click="add()")
      span.fa.fa-clone
      |  Compare
  .clearfix
  table.table.table-hover
    thead
      tr
        th
          .line.info-cell

        th(v-for="(dc, index) in dissectedCodes")
          .flex
            .flex-1
              form(@submit.prevent="dissect(dc)" style="max-width: 600px")
                .input-group
                  input#code-dissector-input.form-control(type='text' v-model="dc.code" placeholder="Enter code" required)
                  span.input-group-btn
                    SspActionButton#dissect-code-button(type="submit" text="Dissect" :spinning="dc.loading" :disabled="!dc.code")
              .lc(style="max-width: 600px; margin-top: 20px; margin-bottom: -10px;")
                .line.info-cell(:class="dc.status")
            .rm-btn
              button.btn.btn-sm.btn-default(v-if="dissectedCodes.length>1" @click.prevent="remove(index)" style="border:0")
                span.fa.fa-remove

    tbody
      tr(v-for="field in fieldDefinitions")
        td
          b {{field.title}}
        template(v-for="dc in dissectedCodes")
          InfoCell(v-if="field.key=='info'" :dissection="dc")
          GenericCell(v-else :dissection="dc" :cellType="field.key" @dissectCodeBundle="dissectCodeBundle")


</template>
<script>
import Core from '@/service/apis/Core'
import LocalStore from '@/service/LocalStore'
import Util from '@/service/Util'
import GenericCell from './components/GenericCell'
import InfoCell from './components/InfoCell'

const recentDissectionsStore = LocalStore.createList('dissector:recentDissections', 10)

function emptyDissection() {
  return {
    code: '',
    loading: false,
    error: null,
    batchValidationResult: null,
    status: 'NONE'
  }
}

export default {
  data() {
    return {
      recentDissections: null,
      dissectedCodes: [emptyDissection()],
      fieldDefinitions: [{
        title: 'Info',
        key: 'info'
      }, {
        title: 'Code',
        key: 'resolvedCode'
      }, {
        title: 'Order id, Code index',
        key: 'ref'
      }, {
        title: 'Code Length',
        key: 'codeLength'
      }, {
        title: 'Code Bundle',
        key: 'codeBundle'
      }, {
        title: 'Section',
        key: 'section'
      }, {
        title: 'Validations',
        key: 'validations'
      }, {
        title: 'Code Creator',
        key: 'creator'
      }, {
        title: 'Order Owner',
        key: 'orderOwner'
      }, {
        title: 'Product',
        key: 'product'
      }, {
        title: 'Configuration',
        key: 'configuration'
      }, {
        title: 'Channels',
        key: 'channels'
      }, {
        title: 'Code Flags',
        key: 'codeFlags'
      }, {
        title: 'Organization',
        key: 'organization'
      }, {
        title: 'SSCC',
        key: 'sscc'
      }]
    }
  },
  created() {
    this.recentDissections = recentDissectionsStore.get()
    if (this.$route.params.code) {
      const dc = this.dissectedCodes[0]
      dc.code = this.cleanCode(this.$route.params.code)
      this.dissect(dc)
    }
  },
  methods: {
    cleanCode(code) {
      return Util.sanitizeCode(code)
    },
    dissectCodeBundle(code) {
      const dc = this.dissectedCodes[0]
      dc.code = this.cleanCode(code)
      this.dissect(dc)
    },
    onHistoryItemClick(code) {
      // TODO: better way for what is current
      const dissection = this.currentDissection

      dissection.code = this.cleanCode(code)
      this.dissect(dissection)
    },

    dissect(val) {
      const dissection = val
      this.reset(dissection)

      recentDissectionsStore.push(this.cleanCode(dissection.code))
      this.recentDissections = recentDissectionsStore.get()
      dissection.code = this.cleanCode(dissection.code)
      // Determine if the user has input an orderId/codeIndex pair
      if (dissection.code.indexOf(',') !== -1) {
        const parts = dissection.code.split(',')
        const orderId = parts[0]
        const codeIndex = parts[1]
        Core.findCode(orderId, codeIndex)
          .then((code) => {
            if (!code) {
              dissection.error = `No code found in order ${orderId} with index ${codeIndex}`
            } else {
              this.dissectUsingBatchValidate(code, dissection)
            }
          })
          .catch((e) => {
            dissection.error = e.response.data.message
          })
          .then(() => {
            dissection.loading = false
          })
      } else {
        Core.codeInfo(dissection.code)
          .then((resp) => {
            if (resp.data && resp.data.length > 0) {
              this.dissectedCodes[0].creator = resp.data[0].creator
              if (resp.data.length === 0) {
                // - No result - Show nothing found. We are done

                // still call batchValidate for consistency
                this.dissectUsingBatchValidate(dissection.code, dissection)
              } else if (resp.data.length === 1) {
                // - One result - Use the code returned to lookup the information to show the normal dissector UI
                this.dissectUsingBatchValidate(resp.data[0].code, dissection)
              } else {
                // - Multiple results - Let the user select the code from the list, then redirect to the normal dissector UI

                // use current dissection for result 0
                this.dissectUsingBatchValidate(resp.data[0].code, dissection)

                // add compare dissecetions for remaining
                for (let i = 1; i < resp.data.length; i += 1) {
                  const added = this.add()
                  this.dissectedCodes[i].creator = resp.data[i].creator
                  this.dissectUsingBatchValidate(resp.data[i].code, added)
                }
              }
            } else {
              dissection.error = `No code: ${dissection.code}`
            }
          })
          .catch((e) => {
            dissection.error = `Error getting code-info: ${e.response.data.message}`
          })
          .then(() => {
            dissection.loading = false
          })
      }
    },
    dissectUsingBatchValidate(code, value) {
      const dissection = value
      dissection.code = this.cleanCode(code)
      return Core.batchValidate({ codes: [code] })
        .then((resp) => {
          const result = resp.data[0]
          dissection.batchValidationResult = result
          dissection.status = result.result.status
          dissection.loading = false
        })
        .catch((e) => {
          dissection.error = e.response.data.message
          dissection.loading = false
        })
    },
    reset(value) {
      const dissection = value
      dissection.loading = true
      dissection.error = null
      dissection.batchValidationResult = null
      dissection.status = 'NONE'
    },
    add() {
      const dissection = emptyDissection()
      this.dissectedCodes.push(dissection)
      return dissection
    },
    remove(index) {
      this.dissectedCodes.splice(index, 1)
    }
  },
  computed: {
    currentDissection() {
      // first empty or last
      for (let i = 0; i < this.dissectedCodes.length; i += 1) {
        if (!this.dissectedCodes[i].code) {
          return this.dissectedCodes[i]
        }
      }
      return this.dissectedCodes[this.dissectedCodes.length - 1];
    }
  },
  components: {
    GenericCell,
    InfoCell
  }
}
</script>
<style lang="scss">
.line.info-cell {
  height: 3px;
  background: white;
}
.info-cell.VERIFIED {
  background: #f0ad4e;
}
.info-cell.VALID {
  background: #5cb85c;
}
.info-cell.INVALID {
  background: #d9534f;
}

.code-dissector {
  table {
    th {
      background-color: white !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/dissector/CodeDissector.vue